import React, {
    useEffect,
    useState,
    useImperativeHandle,
    forwardRef,
  } from "react";
  import PropTypes from "prop-types";
  import { useMediaQuery, useTheme } from "@mui/material";
  
  const TimerVerified = forwardRef(({ expiryTime, onExpire, message }, ref) => {
    const [timeLeft, setTimeLeft] = useState(() => calculateTimeLeft(expiryTime));
    const [isRunning, setIsRunning] = useState(true);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  
    useImperativeHandle(ref, () => ({
      stopTimer: () => {
        setIsRunning(false);
      },
    }));
  
    useEffect(() => {
      if (!isRunning) return;
  
      const timerInterval = setInterval(() => {
        const remainingTime = calculateTimeLeft(expiryTime);
        setTimeLeft(remainingTime);
        if (remainingTime.total <= 0) {
          clearInterval(timerInterval);
          setIsRunning(false);
          if (onExpire) {
            onExpire();
          }
        }else{
          // console.log("remainingTime::", remainingTime)
        }
      }, 1000);
  
      return () => clearInterval(timerInterval);
    }, [expiryTime, onExpire, isRunning]);
  
    const formatTime = (time) => {
      const addLeadingZero = (num) => String(num).padStart(2, "0");
      
      return `${addLeadingZero(Math.max(0, time.hours))}:${addLeadingZero(
        Math.max(0, time.minutes)
      )}:${addLeadingZero(Math.max(0, time.seconds))}`;
    };
  
    return (
      <div>
        <p
          style={{
            fontSize: "1.2rem",
            fontWeight: "900",
            margin: "0",
            padding: "0",
            textAlign: "center",
          }}
        >
          {formatTime(timeLeft)}
        </p>
      </div>
    );
  });
  
  // Helper function to calculate remaining time
  const calculateTimeLeft = (expiryTime) => {
    const now = new Date().getTime();
    const difference = expiryTime - now;
  
    return {
      total: difference,
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / (1000 * 60)) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  };
  
  TimerVerified.propTypes = {
    expiryTime: PropTypes.number.isRequired, // Expiry time as a timestamp
    onExpire: PropTypes.func, // Callback for when timer expires
  };
  
  export default TimerVerified;
  